import idx from "idx"

/**
 * transform - manipulate data for contact
 * @param {object} contactFormFeature - query
 * @returns {object}
 */

function transform(contactFormFeature) {
  const images = contactFormFeature.images
    ? contactFormFeature.images.map(image => {
        return {
          title: idx(image, _ => _.title),
          fluid: idx(image, _ => _.fluid)
        }
      })
    : []
  return { images }
}

export default { transform }
